import React from 'react';
import { connect, MapStateToProps, MapDispatchToProps } from 'react-redux';
import { RootState } from 'store/store';

import messages from './Messages';
import Input from 'components/Input';
import Button from 'components/Button';
import notify from 'components/Notify';
import { SystemConfigView } from 'store/entity/ISystemConfig';
import {
  makhsanUpdateConfig,
  makhsanUpdateConfigFn,
} from 'store/makhsanSystemConfig/makhsanSystemConfigSlice';
import { ConfigItems } from './styles';
import { appDispatch } from 'store/store';

interface IStateToProps {}

interface IDispatchToProps {
  updateConfig: (
    config: SystemConfigView
  ) => ReturnType<typeof makhsanUpdateConfigFn>;
}

interface IOwnProps {
  config: SystemConfigView;
}

type IComponentProps = IOwnProps & IStateToProps & IDispatchToProps;

interface IComponentStates {
  saving: boolean;
  unblocking: boolean;
  dummy?: boolean;
  configValue: string;
}

class ConfigBox extends React.PureComponent<IComponentProps, IComponentStates> {
  constructor(props: IComponentProps) {
    super(props);
    this.state = {
      saving: false,
      unblocking: false,
      configValue: props.config.value || '',
    };
  }
  handleSave = () => {
    this.setState({ saving: true });
    const newConfig = { ...this.props.config };
    newConfig.value = this.state.configValue;
    this.props.updateConfig(newConfig).then(
      () => {
        this.setState({ saving: false });
        notify(messages.configUpdated);
      },
      (message) => {
        notify(message.data.message, 'error');
        this.setState({ saving: false });
      }
    );
  };
  componentDidUpdate(prevProps: Readonly<IComponentProps>): void {
    if (prevProps.config.id !== this.props.config.id)
      this.setState({ configValue: this.props.config.value || '' });
  }

  updateValue = (e: React.ChangeEvent<HTMLInputElement>) => {
    this.setState({ configValue: e.target.value });
  };
  render() {
    const { config } = this.props;
    const { configValue, saving } = this.state;
    return (
      <ConfigItems helve={true}>
        <div className="section">
          <div style={{ fontWeight: 'bold' }}>{config.name}</div>
          <Input
            type="text"
            id="configValue"
            label={messages.value}
            placeholder={messages.value}
            value={configValue}
            onChange={this.updateValue}
          />
          <Button onClick={this.handleSave} loading={saving}>
            {messages.save}
          </Button>
        </div>
      </ConfigItems>
    );
  }
}

const mapStateToProps: MapStateToProps<IStateToProps, IOwnProps, RootState> = (
  state
) => {
  const thisUser = state.thisUser;
  return { thisUser };
};

const mapDispatchToProps: MapDispatchToProps<
  IDispatchToProps,
  IOwnProps
> = () => {
  return {
    updateConfig: (config: SystemConfigView) => {
      return appDispatch(makhsanUpdateConfig({ config }));
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ConfigBox);
